// extracted by mini-css-extract-plugin
export default {"body_text":"social-actions-DisabledSocialAction__body_text--3ZAdS"};